export const Environment = {
  INT: 'int',
  PROD: 'prod',
} as const;

export type Environment = (typeof Environment)[keyof typeof Environment];
